<template>
  <div class="payment">
    <div class="left">
      <div class="top">
        <payment-details-view />
      </div>
      <div class="bottom">
        <payment-change-info-view />
      </div>
    </div>
    <div class="right">
      <div class="headline">Change payment method</div>
      <div class="title">Select payment method</div>
      <div class="vat-check">
        <vat-view
          v-if="
            this.$store.state.customerData.customerType == 2 &&
              customerCountryInsideEu
          "/>
      </div>
      <div>
        <payment-method-view v-if="this.$store.state.subscriptionTypeLoaded &&
            (vatValidToSubmit ||
            (this.$store.state.customerData.customerType != 2 ||
              !customerCountryInsideEu))" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import PaymentChangeInfo from "@/components/Subscription/PaymentChangeInfo.vue";
import PaymentDetailsView from "@/components/Subscription/PaymentDetails.vue";
import PaymentMethodView from "@/components/Checkout/PaymentMethod.vue";
import VatView from "@/components/Checkout/Vat.vue";

export default {
  name: "payment-view",
  props: {
    title: String,
  },
  data() {
    return {
      cancelTokens: {
        getCountries: axios.CancelToken.source(),
        getSubscriptionCustomer: axios.CancelToken.source(),
        getSubscription: axios.CancelToken.source(),
      },
    };
  },
  components: {
    "payment-details-view": PaymentDetailsView,
    "payment-method-view": PaymentMethodView,
    "payment-change-info-view": PaymentChangeInfo,
    "vat-view": VatView,
  },
  computed: {
    vatValidToSubmit() {
      if (
        this.$store.state.vatCheckSuccessfull ||
        this.$store.state.customerData.vatId == "" ||
        this.$store.state.customerData.vatId == null
      ) {
        return true;
      }
      return false;
    },
    customerCountryInsideEu() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null && this.$store.state.customerData.country != 57
        ) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    getCountryWithId(countryId) {
      for (let i = 0; i < this.$store.state.countries.length; i++) {
        if (this.$store.state.countries[i].id == countryId) {
          return this.$store.state.countries[i];
        }
      }
      return null;
    },
  },
  async mounted() {
    if (typeof this.$router.history.current.query.email != "undefined") {
      this.$store.commit("assignPaymentLoading", true);
      await this.$store.dispatch("updateSubscriptionOnRedirect");
    }
    await this.$store.dispatch("getCountries", this.cancelTokens.getCountries);
    await this.$store.dispatch(
      "getSubscriptionCustomer",
      this.cancelTokens.getSubscriptionCustomer
    );
    await this.$store.dispatch(
      "getSubscription",
      this.cancelTokens.getSubscription
    );
    await this.$store.dispatch(
      "getSubscriptionType",
      this.$store.state.subscription.subscription_type_id
    );
    await this.$store.commit("assignSubscriptionTypeLoaded", true);
    this.$store.commit("assignPaymentLoading", false);
  },
  beforeDestroy() {
    this.cancelTokens.getCountries.cancel("View closed");
    this.cancelTokens.getSubscriptionCustomer.cancel("View closed");
    this.cancelTokens.getSubscription.cancel("View closed");
  },
};
</script>

<style scoped>
.vat-check {
  padding-top: 20px;
  padding-bottom: 20px;
}

.payment {
  width: 100%;
  height: 88.5%;
  display: flex;
  justify-content: center;
  padding-top: 30px;
  padding-bottom: 30px;
}

.right {
  border-left: 1px solid #c7c9c8;
  width: 50%;
  height: 100%;
  padding-left: 60px;
  padding-right: 60px;
}

.left {
  width: 50%;
  padding-left: 60px;
  padding-right: 60px;
  border-right: 1px solid #c7c9c8;
}
.headline {
  font-size: 20px;
  margin-bottom: 15px;
}

.title {
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  width: 100%;
  height: 30px;
  font-size: 15px;
}
</style>
